import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./components/Home";
import Update from "./components/Update";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/update" element={<Update />}></Route>
      </Routes>
    </Router>
  );
};

export default App;
